<div class="title p-grid p-nogutter">
  <div class="title__section p-col-fixed">
    <div class="title__logo" [ngClass]="logoClass"></div>
  </div>
  <div class="title__section p-col p-dir-col">
    <div class="title__application-name">{{ applicationName }}</div>
    <div class="title__current-machine">{{ workCenterName }}</div>
  </div>
</div>
